import { z } from 'zod';
import type { cashFlowTypeSchema } from './cash_flow';
import type { detailedTransactionTypeSchema } from './transaction_type';
import type { accountReferenceSchema } from './account';

const entryInfoSchema = <
  InfoSchema extends
    | typeof detailedTransactionTypeSchema
    | typeof cashFlowTypeSchema
    | typeof accountReferenceSchema,
>(
  infoSchema: InfoSchema,
) =>
  z.discriminatedUnion('type', [
    z.object({
      type: z.literal('None'),
    }),
    z.object({
      type: z.literal('Unique'),
      data: infoSchema,
    }),
    z.object({
      type: z.literal('Multiple'),
    }),
  ]);

export { entryInfoSchema };
